// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.rspc[data-v-a186b676] {\n  padding: 8px 8px;\n  width: 210px;\n}\n.rspc__header[data-v-a186b676] {\n  background: #39434e;\n  color: #fff;\n  padding: 8px;\n  margin-top: 8px;\n  margin-bottom: 32px;\n  font: 19px/11px Noto Sans JP;\n  font-weight: 300;\n  line-height: 100%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
